module.exports = __webpack_public_path__ + "res/24-img_more.44926fdf8836a1f20c21b030cd3fcfe8.png";